module.exports = __webpack_public_path__ + "static/media/gplayQR.6cc9fdea.png";